import React from 'react';

import { Colors } from '../../../themes/colors';
import { Table } from '../Table/Table';
import { ROWS_PER_PAGE } from './hooks/useGiftCardRedemption';
import { useProfessionalChallenge } from './hooks/useProfessionalChallenge';
import { properksProfessionalChallengeColumn } from './utils';
import { properksChallengeConditionalRowStyles } from '../../mainComponents/ProPerks/utils';
import { LegendItem } from '../../mainComponents/ProPerks/components/ProperksChallengeList';

export const ProperksProfessionalChallenge = () => {
  const { data, isLoading, total, totalPages, handleTableChange, status, setStatus } =
    useProfessionalChallenge();

  const getColumn = () => properksProfessionalChallengeColumn();

  const showFilterStatus = () => (
    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: 16 }}>
      <span style={{ fontWeight: 'bold' }}>Status:</span>
      <select
        className="custom-select custom-select-lg"
        style={{ width: 154 }}
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option className="dropdown-item" value="all">
          All
        </option>
        <option className="dropdown-item" value="active">
          Active
        </option>
        <option className="dropdown-item" value="inactive">
          Inactive
        </option>
      </select>
    </div>
  );

  return (
    <div
      className="card mt-3 ml-4 mr-4 mb-3"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '80%',
        padding: '0px 90px',
      }}
    >
      <h1
        className="global_font f-dark"
        style={{
          fontSize: 24,
          fontWeight: 'bold',
          marginTop: 45,
          marginBottom: 30,
          marginLeft: 30,
          textAlign: 'center',
        }}
      >
        Challenges
      </h1>

      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 60,
        }}
      >
        <Table
          keyField="properks.id"
          columns={getColumn()}
          data={data}
          noDataComponent="No Challenge for this Professional"
          isLoading={isLoading}
          forceLoading={isLoading}
          showColumnsToHide={false}
          showTotal
          customStyles={{
            headCells: {
              style: {
                fontSize: 13,
                fontWeight: 'bold',
                width: '100%',
              },
            },
            rows: {
              style: {
                minHeight: '44px',
              },
            },
          }}
          paginationPerPage={ROWS_PER_PAGE}
          paginationTotalRows={total}
          totalPages={totalPages}
          onPageChange={handleTableChange}
          conditionalRowStyles={properksChallengeConditionalRowStyles}
          CustomHeaderComponent={() => (
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginRight: 25,
                gap: 10,
              }}
            >
              <div>{showFilterStatus()}</div>
              <div style={{ display: 'flex', gap: 16 }}>
                <LegendItem color={Colors.background_60} text="Active" />
                <LegendItem color={Colors.neutral_100} text="Inactive" />
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};